"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlotRowModel = void 0;
class SlotRowModel {
    isSlotRow;
    slotName;
    bindings;
    trClass;
    tdClass;
    ruler;
    constructor(slotName, bindings, options) {
        this.isSlotRow = true;
        this.slotName = slotName;
        this.bindings = bindings;
        this.trClass = options && options.trClass ? options.trClass : null;
        this.tdClass = options && options.tdClass ? options.tdClass : null;
        this.ruler = options && options.ruler ? options.ruler : false;
    }
}
exports.SlotRowModel = SlotRowModel;
//# sourceMappingURL=slot-row-model.js.map